import { gql } from '@apollo/client';
export const templateQuery = gql `
  query GetTemplateName($id: Unstable__UUID!) {
    template: unstable__template(id: $id) {
      id

      composerTemplates {
        id
        composer {
          id
          metadata {
            name
            marketLocaleCode
          }
        }
      }
    }
  }
`;
